import { type TFunction } from "i18next";

import { FALLBACK_CARD_TITLE, getCardDescriptionKey } from "@/features/card";

import { getCardTypeForAccountType } from "../types/available-payment-methods";

export function describePaymentAccount({
  accountType,
  identifier,
  title,
  t,
}: {
  accountType: string;
  identifier?: string;
  /** Localized account title from the backend, shown for a card with no identifier. */
  title?: string;
  t: TFunction;
}) {
  if (!accountType) {
    return undefined;
  }

  // A card account with an identifier is described from its Card Type. Without
  // one it falls back to the backend's localized title, like the card list.
  const cardType = getCardTypeForAccountType(accountType);
  if (cardType) {
    return identifier
      ? t(getCardDescriptionKey(cardType), { "0": identifier.slice(-4) })
      : title || FALLBACK_CARD_TITLE;
  }

  return {
    BANK_ACCOUNT: identifier
      ? t("claimDetail_bankDescription", {
          "0": identifier.slice(-4),
        })
      : t("payment_bankAccount"),
    DEBIT_CARD: identifier
      ? t("claimDetail_cardDescription", {
          "0": identifier.slice(-4),
        })
      : t("payment_debitCard"),
  }[accountType];
}
